import React, { useRef } from "react";
import { getStepperChaptersFromLayout } from "../../../../helpers";
import { useTranslation } from "react-i18next";

export const CaseStepper = (props: any) => {
  const { layout, current } = props;
  const { t } = useTranslation();
  const chapters = getStepperChaptersFromLayout(layout, current);

  const ref = useRef(null);

  let stepCount = 0;
  const stepsToShow = 3;
  const stepsToShowTablet = 4;
  const stepsToShowDesktop = 8;
  let showStep = true;
  let showStepTablet = true;
  let showStepDesktop = true;

  const VisuallyHidden = ({ children }: { children: React.ReactNode }) => (
    <span className="visually-hidden">{children}</span>
  );
  return (
    <nav
      className={`${"Stepper justify-content-"}${
        chapters.length < stepsToShow ? "center" : "start"
      }`}
      ref={ref}
      role="list"
      aria-label={t("aria.form.stepper.aria.label")}
    >
      {chapters.map((chapter, index) => {
        const { chapterName, children, startingAt } = chapter;
        const [firstChild, ...otherChildren] = children;
        let isActiveChapter: any;
        let isCompletedChapter = props.current >= startingAt;
        if (index === chapters.length - 1) {
          isActiveChapter = props.current >= startingAt;
        } else {
          isActiveChapter =
            props.current >= startingAt &&
            props.current < chapters[index + 1].startingAt;
        }

        const otherChildrenActive = otherChildren.findLastIndex(
          (item: { visited: any }) => item.visited
        );

        let subchaptersClass = "";
        if (isActiveChapter) {
          subchaptersClass = "active";
        } else if (isCompletedChapter) {
          subchaptersClass = "completed";
        } else {
          subchaptersClass = "future";
        }
        if (chapters.length > stepsToShow) {
          const isTheNextStepVisited =
            index < chapters.length - 1
              ? chapters[index + 1].children[0].visited
              : false;
          if (firstChild.visited) {
            stepCount = index;
          }
          showStep =
            (!isTheNextStepVisited ||
              stepCount + stepsToShow >= chapters.length) &&
            (stepCount >= index || stepCount + stepsToShow > index);
          showStepTablet =
            (!isTheNextStepVisited ||
              stepCount + stepsToShowTablet >= chapters.length) &&
            (stepCount >= index || stepCount + stepsToShowTablet > index);
          showStepDesktop =
            (!isTheNextStepVisited ||
              stepCount + stepsToShowDesktop >= chapters.length) &&
            (stepCount >= index || stepCount + stepsToShowDesktop > index);
        }
        console.log(chapterName);
        return (
          <ol
            key={`stepper-${index}`}
            className={`${showStep ? "" : "hidden-step"} ${
              showStepTablet ? "" : "hidden-step-tablet"
            } ${showStepDesktop ? "" : "hidden-step-desktop"}`}
            role="listitem"
            aria-current={isActiveChapter ? "true" : "false"}
            aria-label={t("aria.form.stepper.aria.label")}
          >
            {[firstChild].map((child, childIndex) => {
              const currentClass =
                isActiveChapter && otherChildren.length <= 1
                  ? "current-step"
                  : "";
              return (
                <li
                  key={`stepper-item${childIndex}`}
                  className={`chapter-circle ${
                    firstChild.visited ? "visited" : ""
                  } ${currentClass} ${isActiveChapter ? "text-active" : ""}`}
                  role="presentation"
                  aria-label={
                    "Step: " +
                    (chapterName?.props?.i18nKey
                      ? t(chapterName?.props?.i18nKey)
                      : chapterName)
                  }
                >
                  <VisuallyHidden>
                    {(isActiveChapter
                      ? t("aria.form.stepper.current")
                      : isCompletedChapter
                      ? t("aria.form.stepper.completed")
                      : "") +
                      " Step " +
                      (index + 1) +
                      t("aria.form.common.di") +
                      chapters.length}
                  </VisuallyHidden>
                  <span className={"number"} aria-hidden="true">
                    {index + 1}
                  </span>
                  <span className={"title"} aria-hidden="true">
                    {isActiveChapter || isCompletedChapter ? chapterName : ""}
                  </span>
                </li>
              );
            })}
            <div className={`subchapters ${subchaptersClass} `}>
              <ol className="inner">
                {otherChildren.length > 1
                  ? otherChildren.map(
                      (child: { visited: any }, childIndex: any) => {
                        const { visited } = child;
                        const style = {
                          width: `${100 / otherChildren.length}%`,
                        };
                        return (
                          <li key={`stepper-item${childIndex}`} style={style}>
                            <div
                              className={`subchapter-circle ${
                                visited && "visited"
                              } ${
                                isActiveChapter &&
                                otherChildrenActive === childIndex
                                  ? "active-sub-chapter"
                                  : ""
                              }`}
                            />
                          </li>
                        );
                      }
                    )
                  : otherChildren.map((child: any, childIndex: any) => {
                      const style = { width: `${100 / otherChildren.length}%` };
                      return (
                        <li key={`stepper-item${childIndex}`} style={style}>
                        </li>
                      );
                    })}
              </ol>
            </div>
          </ol>
        );
      })}
    </nav>
  );
};
